import { Stack, useBreakpointValue } from "@chakra-ui/react";

import ConditionCheck from "components/ConditionCheck";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { UnauthorizedError } from "components/Unauthorized/Unauthorized";
import { useRequestParams } from "contexts/RequestParamsProvider";
import useFeatureFlag from "hooks/useFeatureFlag";
import useFetchPermissions from "hooks/api/customers/useFetchPermissions";
import usePermission from "hooks/usePermission";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import useUserManagementRoles from "hooks/api/customers/useUserManagementRoles";
import { USER_MANAGEMENT } from "util/featureFlags";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import UserManagementTable from "./UserManagementTable";

const marginTop = mobileStyleBreakpoint<string>("20px", "80px");

const UserManagementPage = () => {
  const { searchTerm, activeSort } = useRequestParams();

  const selectedCustomerCode = useSelectedCustomerCode()[0];
  const { data: userManagementRoles, isLoading } = useUserManagementRoles(
    selectedCustomerCode,
    searchTerm,
    activeSort
  );

  const hasUserAdminFeatureFlag = useFeatureFlag(USER_MANAGEMENT.VIEW);
  const { isLoading: permissionsLoading } = useFetchPermissions();
  const hasUserAdminPermission = usePermission(USER_MANAGEMENT.VIEW);

  const userManagementTableMargin = useBreakpointValue(marginTop);

  if (permissionsLoading || isLoading) {
    return <LoadingSpinner />;
  }
  if (!hasUserAdminPermission) {
    throw new UnauthorizedError("User lacks User Management permission", {
      feature: "User Management",
    });
  }

  return (
    <Stack style={{ marginTop: userManagementTableMargin }}>
      <ConditionCheck conditions={[hasUserAdminFeatureFlag]}>
        <UserManagementTable users={userManagementRoles} />
      </ConditionCheck>
    </Stack>
  );
};

export default UserManagementPage;
